module.exports = "/packs/media/images/icons/default_wealth-3d60cf4b41f3c2262d05e92429fb2e53.png";